/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type TimeSlot_timeSlot = {|
  +id: string;
  +startDate: any;
  +duration: {|
    +hours: number;
    +minutes: number;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeSlot_timeSlot",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "id",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "startDate",
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Duration",
      "name": "duration",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "hours",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "minutes",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TimeSlot"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/modules/job/components/__generated__/TimeSlot_timeSlot.graphql.js